/* eslint-disable react/prop-types */
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import HeaderPDF from './HeaderPDF';
// Define styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
 
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20,
    textDecoration: 'underline',
  },
  subtitle: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 20,
    fontStyle: 'italic',
  },
  section: {
    marginBottom: 15,
    padding: 10,
    border: '1px solid #000',
  },
  sectionHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10,
    backgroundColor: '#f0f0f0',
    padding: 5,
    textAlign: 'center',
  },
  row: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'flex-start',
  },
  label: {
    fontSize: 10,
    fontWeight: 'bold',
    minWidth: 100,
    marginRight: 10,
  },
  value: {
    fontSize: 10,
    flex: 1,
    borderBottom: '1px solid #000',
    paddingBottom: 2,
    minHeight: 12,
  },
  textArea: {
    border: '1px solid #000',
    padding: 5,
    minHeight: 30,
    fontSize: 9,
    lineHeight: 1.2,
    marginBottom: 8,
  },
  twoColumn: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  column: {
    width: '48%',
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 20,
    paddingTop: 10,
    borderTop: '1px solid #000',
  },
  signatureBox: {
    width: '22%',
    textAlign: 'center',
  },
  signatureLine: {
    borderBottom: '1px solid #000',
    marginBottom: 5,
    minHeight: 30,
    fontSize: 9,
    paddingTop: 15,
  },
  signatureLabel: {
    fontSize: 8,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  pageBreak: {
    marginTop: 20,
    pageBreak: 'before',
  },
});

const ExportPDFFilipinoEmploymentContract = ({ formData, user,agencyInfo }) => {
 
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header with company info */}
        <HeaderPDF user={user} agencyInfo={agencyInfo} />

        <Text style={styles.title}>
          Filipino Employment Contract
        </Text>
        <Text style={styles.subtitle}>
          Standard Employment Contract for Foreign Domestic Helpers from the Philippines
        </Text>

        {/* Employer Information */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Employer Information</Text>
          
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Name:</Text>
                <Text style={styles.value}>{formData.employerName || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Status:</Text>
                <Text style={styles.value}>{formData.employerStatus || ''}</Text>
              </View>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Address:</Text>
            <View style={styles.textArea}>
              <Text>{formData.employerAddress || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Contact:</Text>
            <Text style={styles.value}>{formData.employerContact || ''}</Text>
          </View>
        </View>

        {/* FPA Information */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>FPA Information</Text>
          
          <View style={styles.row}>
            <Text style={styles.label}>FPA Name:</Text>
            <Text style={styles.value}>{formData.fpaName || ''}</Text>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>FPA Address:</Text>
            <View style={styles.textArea}>
              <Text>{formData.fpaAddress || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>FPA Contact:</Text>
            <Text style={styles.value}>{formData.fpaContact || ''}</Text>
          </View>
        </View>

        {/* HSW Information */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Household Service Worker (HSW) Information</Text>
          
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Name:</Text>
                <Text style={styles.value}>{formData.hswName || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Status:</Text>
                <Text style={styles.value}>{formData.hswStatus || ''}</Text>
              </View>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Address:</Text>
            <View style={styles.textArea}>
              <Text>{formData.hswAddress || ''}</Text>
            </View>
          </View>

          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Contact:</Text>
                <Text style={styles.value}>{formData.hswContact || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Passport No:</Text>
                <Text style={styles.value}>{formData.hswPassport || ''}</Text>
              </View>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Passport Issue Date:</Text>
            <Text style={styles.value}>{formData.hswPassportIssue || ''}</Text>
          </View>
        </View>

        {/* PRA Information */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>PRA Information</Text>
          
          <View style={styles.row}>
            <Text style={styles.label}>PRA Name:</Text>
            <Text style={styles.value}>{formData.praName || ''}</Text>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>PRA Address:</Text>
            <View style={styles.textArea}>
              <Text>{formData.praAddress || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>PRA Contact:</Text>
            <Text style={styles.value}>{formData.praContact || ''}</Text>
          </View>
        </View>
      </Page>

      {/* Second Page - Employment Terms and Additional Information */}
      <Page size="A4" style={styles.page}>
        {/* Employment Terms */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Employment Terms</Text>
          
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Work Site:</Text>
                <Text style={styles.value}>{formData.site || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Duration:</Text>
                <Text style={styles.value}>{formData.duration || ''}</Text>
              </View>
            </View>
          </View>

          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Monthly Salary:</Text>
                <Text style={styles.value}>S$ {formData.salary || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Work Hours:</Text>
                <Text style={styles.value}>{formData.workHours || ''}</Text>
              </View>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Rest Day:</Text>
            <Text style={styles.value}>{formData.restDay || ''}</Text>
          </View>
        </View>

        {/* Additional Terms */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Additional Terms</Text>
          
          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Transportation:</Text>
            <View style={styles.textArea}>
              <Text>{formData.transport || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Accommodation:</Text>
            <View style={styles.textArea}>
              <Text>{formData.accommodation || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Medical Benefits:</Text>
            <View style={styles.textArea}>
              <Text>{formData.medical || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Vacation Leave:</Text>
            <View style={styles.textArea}>
              <Text>{formData.vacation || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Insurance:</Text>
            <View style={styles.textArea}>
              <Text>{formData.insurance || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Death Benefits:</Text>
            <View style={styles.textArea}>
              <Text>{formData.death || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Remittance:</Text>
            <View style={styles.textArea}>
              <Text>{formData.remittance || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Termination:</Text>
            <View style={styles.textArea}>
              <Text>{formData.termination || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Disputes:</Text>
            <View style={styles.textArea}>
              <Text>{formData.disputes || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Special Provisions:</Text>
            <View style={styles.textArea}>
              <Text>{formData.special || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Amendments:</Text>
            <View style={styles.textArea}>
              <Text>{formData.amendments || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Force Majeure:</Text>
            <View style={styles.textArea}>
              <Text>{formData.forceMajeure || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Others:</Text>
            <View style={styles.textArea}>
              <Text>{formData.others || ''}</Text>
            </View>
          </View>
        </View>

        {/* Signatures */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureBox}>
            <View style={styles.signatureLine}>
              <Text>{formData.hswSignature || ''}</Text>
            </View>
            <Text style={styles.signatureLabel}>HSW Signature</Text>
          </View>

          <View style={styles.signatureBox}>
            <View style={styles.signatureLine}>
              <Text>{formData.employerSignature || ''}</Text>
            </View>
            <Text style={styles.signatureLabel}>Employer Signature</Text>
          </View>

          <View style={styles.signatureBox}>
            <View style={styles.signatureLine}>
              <Text>{formData.praSignature || ''}</Text>
            </View>
            <Text style={styles.signatureLabel}>PRA Signature</Text>
          </View>

          <View style={styles.signatureBox}>
            <View style={styles.signatureLine}>
              <Text>{formData.fpaSignature || ''}</Text>
            </View>
            <Text style={styles.signatureLabel}>FPA Signature</Text>
          </View>
        </View>
      </Page>

      {/* Third Page - Undertakings */}
      <Page size="A4" style={styles.page}>
        {/* Undertaking by Employer */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Undertaking by Employer</Text>
          
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Name:</Text>
                <Text style={styles.value}>{formData.undertakeEmployerName || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>Address:</Text>
                <Text style={styles.value}>{formData.undertakeEmployerAddress || ''}</Text>
              </View>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>Employer Undertaking:</Text>
            <View style={[styles.textArea, { minHeight: 60 }]}>
              <Text>{formData.employerUndertaking || ''}</Text>
            </View>
          </View>
        </View>

        {/* FPA Undertaking */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>FPA Undertaking</Text>
          
          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>FPA Owner:</Text>
                <Text style={styles.value}>{formData.fpaOwner || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>FPA Agency:</Text>
                <Text style={styles.value}>{formData.fpaAgency || ''}</Text>
              </View>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>FPA Agency Address:</Text>
            <View style={styles.textArea}>
              <Text>{formData.fpaAgencyAddress || ''}</Text>
            </View>
          </View>

          <View style={{ marginBottom: 8 }}>
            <Text style={[styles.label, { marginBottom: 2 }]}>FPA Undertaking:</Text>
            <View style={[styles.textArea, { minHeight: 60 }]}>
              <Text>{formData.fpaUndertaking || ''}</Text>
            </View>
          </View>

          <View style={styles.twoColumn}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>FPA Signature:</Text>
                <Text style={styles.value}>{formData.fpaSignature2 || ''}</Text>
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text style={styles.label}>FPA Stamp:</Text>
                <Text style={styles.value}>{formData.fpaStamp || ''}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Final Declaration */}
        <View style={[styles.section, { marginTop: 40 }]}>
          <Text style={{ fontSize: 10, textAlign: 'center', fontWeight: 'bold', marginBottom: 10 }}>
            Declaration
          </Text>
          <Text style={{ fontSize: 9, lineHeight: 1.4, textAlign: 'justify' }}>
            This contract has been duly executed by all parties involved and shall be binding upon the parties, 
            their heirs, successors, and assigns. All parties acknowledge that they have read, understood, 
            and agree to be bound by all the terms and conditions set forth herein.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default ExportPDFFilipinoEmploymentContract;
